import React from 'react';
import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles';
import IconClose from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { COLORS } from 'config/theme';
import avatarImg from 'images/console-users/user-avatar-1.svg';

import ViewTabs from '../ViewTabs';

const styles = {
  titleButton: {
    width: 35,
    height: 35,
    marginRight: 15,
  },
};

const StyledHeader = styled.header`
  display: flex;
  align-items: center;
  height: 49px;
`;

const Title = styled.h3`
  display: flex;
  align-items: center;
  width: 360px;
  padding-left: 18px;
  color: ${COLORS.primaryColor};
  font-size: 15px;
  letter-spacing: 0.3px;
  font-weight: 400;
`;

const Avatar = styled.img`
  width: 29px;
  margin-right: 5px;
`;

const Header = ({
  user_id,
  selectedEvent,
  handleViewChange,
  classes,
  handleCloseDrawer,
}) => {
  return (
    <StyledHeader>
      <Title>
        <IconButton
          className={classes.titleButton}
          onClick={handleCloseDrawer}
        >
          <IconClose />
        </IconButton>

        <Avatar src={avatarImg} alt="" />
        {user_id}
      </Title>

      <ViewTabs
        selectedEvent={selectedEvent}
        handleViewChange={handleViewChange}
      />
    </StyledHeader>
  );
};

export default withStyles(styles)(Header);



// WEBPACK FOOTER //
// ./src/components/IterioApp/Users/Details/Header/Header.jsx